import { makeStyles } from "@material-ui/core/styles";
import { Box, Card, CardContent, Typography } from "@material-ui/core";
import HistoryIcon from "@mui/icons-material/History";

import componentStyles from "assets/theme/components/cards/cards/card-header.js";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useCustomStyles = makeStyles({
  td_style: {
    textAlign: "center",
    width: "100px",
  },
  th_style: {
    textAlign: "center",
    width: "100px",
  },
  border_style: {
    borderBottom: "0.05rem solid black",
    borderCollapse: "collapse",
    padding: "0.25rem 0",
  },
});

const INDICATORS = [
  { key: "TotalCastradoUsuario", label: "Clientes Cadastro no Mês" },
  {
    key: "TotalAcessoUmaVez",
    label: "Clientes que acessaram o portal pelo menos uma vez",
  },
  {
    key: "TotalAcessoPorCliente",
    label: "Quantidade de acessos no portal por clientes",
  },
  { key: "TotalBoletosBaixados", label: "Boletos baixados" },
  { key: "TotalNotasFiscais", label: "Consulta de notas fiscais" },
  { key: "TotalPosicaoPedido", label: "Posição de pedidos" },
  { key: "TotalPosicaoEntrega", label: "Posição de entregas" },
];

const getCurrentMonth = () => {
  return new Intl.DateTimeFormat("pt-BR", { month: "long" })
    .format(new Date())
    .replace(/^\w/, (c) => c.toUpperCase());
};

export default function CardAccessIndicators({ data, type }) {
  const isMobile = IsMobile();

  const month = getCurrentMonth();

  const fontStyleFirst = {
    fontSize: isMobile ? "0.75rem" : "0.85rem",
    minWidth: "10rem",
  };

  const fontStyle = {
    fontSize: isMobile ? "0.75rem" : "0.85rem",
  };

  const classes = {
    ...useStyles(),
    ...useCustomStyles(),
  };

  return (
    <Card
      className={classes.cardRoot}
      style={{
        minWidth: "13rem",
        minHeight: "350px",
        alignItems: "flex-start",
        overflowX: isMobile ? "auto" : "hidden",
      }}
    >
      <CardContent>
        <Typography
          variant={type === "month" ? "h3" : "h2"}
          component={Box}
          style={{ marginBottom: "1rem" }}
        >
          {type === "semester" && <HistoryIcon />}
          {type === "month"
            ? ` Indicadores de ${month}`
            : " Histórico - Últimos 6 meses"}
        </Typography>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th className={classes.border_style}></th>
              {type === "semester" ? (
                data?.map((mes) => (
                  <th
                    key={mes?.IdUsuario}
                    className={classes.th_style + " " + classes.border_style}
                    style={{
                      minWidth: isMobile ? "5.15rem" : "4rem",
                      fontSize: isMobile ? "0.7rem" : "0.85rem",
                    }}
                  >
                    {mes?.DataHoraFormat || "-"}
                  </th>
                ))
              ) : (
                <th
                  className={classes.th_style + " " + classes.border_style}
                  style={{
                    minWidth: isMobile ? "5.15rem" : "4rem",
                    fontSize: isMobile ? "0.7rem" : "0.85rem",
                  }}
                >
                  {" "}
                </th>
              )}
              <th style={{ minWidth: "20px" }}></th>
            </tr>
          </thead>
          <tbody>
            {INDICATORS.map((indicator, index) => (
              <tr key={indicator.key}>
                <td className={classes.border_style} style={fontStyleFirst}>
                  {indicator.label}
                </td>
                {data?.map((item, index) => (
                  <td
                    key={index}
                    style={fontStyle}
                    className={classes.td_style + " " + classes.border_style}
                  >
                    {item?.[indicator.key] || "0"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
